import http from "@/utils/http";
import { Message } from "@arco-design/web-react";
// 查询收藏音乐列表
export async function getCollectMusic(params): Promise<any> {
  try {
    const res = await http.get("/api/v1/editing/music/list", {
      params
    });
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    console.log(err);
  }
}

// 取消收藏音乐
export async function deleteCollectMusic(data): Promise<any> {
  try {
    const res = await http.delete("/api/v1/editing/music/favorite", data);
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    Message.error(err);
  }
}

// 删除自定义音乐
export async function deleteMusic(data): Promise<any> {
  try {
    const res = await http.delete("/api/v1/editing/music/batch", data);
    if (res) {
      return res;
    } else {
      console.log("接口错误");
    }
  } catch (err) {
    Message.error(err);
  }
}

// 查询所有音乐文件夹
export const getAllMusicFolders = async (params)=> {
  const result = await http.get(`/api/v1/editing/music/folder/find`, {params});
  return result.data;
};

import { clearEmpty } from "../common";
import MaterialCard, {
  CardTypeEnum,
} from "@/pages/CreationSpace/components/MaterialCard/MaterialCard";
import { ProjectNavTypeEnum } from "@/stores/spaceStore/projectStore";
import { ProjectTypeEnum } from "@/pages/CreationSpace/components/ProjectCard/ProjectCard";
import { IMaterialDetail } from "../createSpace/graphQ/getSimpleMedia";
import {IGetAllPortfolioFolderRequest} from "@/services/createSpace/portfolio";
import {IMusicResponse} from "@/services/mixCutDetail/mixCutDetail";

export interface ICreateFolderProps {
  path: string;
}

export interface MaterialRequest {
  type?: string | number;
  parentId: string | number;
  // sortField?: string;
  sortSc?: string;
  keyword?: string;
  page?: number;
  pageSize?: number;
}

export interface CreateFolderResponse {
  id: string;
  updateTime: string;
}
// export interface IGetMaterialDataResponse {
//   created_at: number;
//   id: string;
//   name: string;
//   project_id: string;
//   type: number | string;
//   updated_at: number;
// }

const format = (data: MaterialRequest) => {
  return {
    type: data.type || "",
    parent_id: data.parentId || 0,
    // sort_field: data.sortField || "",
    sort_sc: data.sortSc || "",
    keyword: data.keyword || "",
    page: data.page,
    page_size: data.pageSize,
  };
};

export const toProcessType = (item: IMaterialDetail) => {
  const obj = {
    0: CardTypeEnum.PICTURE,
    1: CardTypeEnum.MOVIE,
    2: CardTypeEnum.MUSIC,
    3: CardTypeEnum.PICTURE,
    4: ProjectTypeEnum.FOLDER,
    5: CardTypeEnum.PIECES
  };
  return obj[item?.type] ? { ...item, type: obj[item?.type] } : undefined;
};

// 修改资源文件名
export const reNameMaterial = async (name: string, id: string) => {
  const result = await http.put(`/api/v1/editing/music/folder/rename`, {
    id: id,
    new_name: name,
  });
  return result;
};

//批量删除资源
/**
 * state true 放入回收站 false 彻底删除
 */
export const deleteMaterial = async (
  ids: string[] | string,
  state: boolean,
) => {
  const result = await http.delete(`/api/v1/editing/music/folder`, {
    data: {
      id: ids,
    },
  });
  return result;
};

/**
 * 批量复制素材或者文件夹
 */
export const copyMaterailsOrFolders = async (
  ids: string[] | string,
  project_id: number,
) => {
  const newIds = Array.isArray(ids)
    ? ids.map((item) => Number(item))
    : [Number(ids)];
  const result = await http.post(`/api/v1/space/material/batch/copy`, {
    ids: newIds,
    project_id,
  });
  return result;
};

export interface IMoveRequest {
  ids: number | number[];
  targetParentId: number;
  projectId: number;
}

const idToNumberList = (
  ids: number | string | number[] | string[],
): number[] => {
  if (Array.isArray(ids)) {
    return ids.map((item) => Number(item));
  }
  return [Number(ids)];
};

export const moveFileAndFolder = async (data: IMoveRequest) => {
  const result = await http.post(`/api/v1/space/material/batch/move`, {
    ids: idToNumberList(data.ids),
    target_parent_id: Number(data.targetParentId),
    project_id: Number(data.projectId),
  });
  return result;
};

export const copyToFileAndFolder = async (data: IMoveRequest) => {
  const result = await http.post(`/api/v1/space/material/batch/copy`, {
    ids: idToNumberList(data.ids),
    target_parent_id: Number(data.targetParentId),
    project_id: Number(data.projectId),
  });
  return result;
};

export type SourceType =
  | "music"
  | "cover"
  | "background"
  | "music_sound"
  | "video";

export interface IMaterialLinkEngineering {
  editing_session_id: number[];
  material_id: number;
  source: SourceType;
}

//素材批量关联工程
export const materialLinkEngineering = async (
  data: IMaterialLinkEngineering,
) => {
  const newData = {
    ...data,
    material_id: [data.material_id],
  };
  const result = await http.post(`/api/v1/editing/material/bind`, {
    ...newData,
  });
  return result;
};

export const batch_download = async (data) => {
  const result = await http.post(`/api/v1/space/media/batch_download`, data);
  return result;
};

// 查询所有文件夹
export const getAllMaterialFolders = async (params)=> {
  const result = await http.get(`/api/v1/space/material/folders/project`, {params});
  return result.data;
};
// 查询所有文件夹
export const musicBindFolders = async (data)=> {
  const result = await http.post(`/api/v1/editing/music/bind`, data);
  return result.data;
};
// 查询所有文件夹
export const musicMoveApi = async (data)=> {
  const result = await http.put(`/api/v1/editing/music/move`, data);
  return result.data;
};

export const createFolder = async (
  data: ICreateFolderProps,
): Promise<CreateFolderResponse> => {
  const result = await http.post(`/api/v1/editing/music/folder`, {
    path: data.path,
  });
  return {
    id: result.data.folder_id,
    updateTime: result.data.updated_at,
  };
};

export const getMusicList = async (data) => {
  const result = await http.post(
    `/api/v1/graphql/`,
    `{
  music_list(page: ${data.page}, page_size: ${data.page_size},order_by: "${data.order_by || "created_at" }", keyword: "${data.keyword}", custom_music_id:${data.id},order_type: "${data.order_type || "desc"}" ){
  	items{      
      id        
      project_id      
      level      
      search_path      
      name      
      media_id      
      type      
      file_type      
      file_size      
      format_name      
      bitrate      
      width      
      height      
      duration      
      source      
      status      
      creator      
      created_at      
      updated_at         
      parent_id      
      fps      
      num_frames      
      file_name      
      play_info{              
        play_url             
        cover_url      
      }
      file_url
      music_type
      music_library_id
    }   
    total,
    base_url
  }
}`,
    {
      headers: {
        "Content-type": "application/graphql",
      },
    },
  );
  return result.data.music_list;
};

export const toIdGetMusicList = async (
  data
) => {
  const result = await http.get(`/api/v1/editing/music`, {
    params: {
      collection_id: data.id,
      type: "1",
      page: data.page,
      page_size: data.page_size,
      field: data.keyword
    },
  });
  const baseUrl = result.data.base_url;
  return ({
    list: (result.data?.items || []).map((item) => {
      return {
        ...item,
        url: baseUrl + item.file_url,
        cover_url: baseUrl + item.cover_url,
      };
    }),
    total: result.data.next_cursor
  })
}
